class NewsletterPopup extends HTMLElement {
    constructor() {
        super();
        this.popup = this;
    }

    connectedCallback() {
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay')) || 0;
        this.expiresDate = this.popup.getAttribute('data-expire') || 7; // Default expiration

        if (this.getCookie('newsletter-popup') === '') {
            setTimeout(() => {
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700);
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        // Check if elements exist before adding event listeners
        const closeButton = this.querySelector('[data-close-newsletter-popup]');
        const form = this.querySelector('#ContactPopup');

        if (closeButton) {
            closeButton.addEventListener('click', this.setClosePopup.bind(this));
        }

        if (form) {
            form.addEventListener('submit', this.setClosePopup.bind(this));
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (let c of ca) {
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return '';
    }

    deleteCookie(name) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
    }

    setClosePopup() {
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target) &&
            !event.target.closest('[data-open-newsletter-popup]') &&
            document.body.classList.contains('newsletter-show')) {
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const closeButton = this.querySelector('[data-close-newsletter-message-popup]');
        
        if (closeButton) {
            closeButton.addEventListener('click', this.close.bind(this));
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close() {
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
